<template>
  <div class="font-sans min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
    <div class="flex-grow pb-12 lg:pb-20">
      <!-- Hero Section -->
      <section
        class="relative bg-blue-50 dark:bg-gray-900 pt-6 pb-8 lg:pt-10 lg:pb-12 overflow-hidden border-b border-gray-100 dark:border-gray-700"
      >
        <!-- Watermark Background -->
        <div
          class="absolute inset-0 opacity-[0.03] pointer-events-none overflow-hidden flex flex-wrap content-start"
        >
          <svg
            v-for="i in 150"
            :key="i"
            class="w-16 h-16 text-[#293146] dark:text-gray-700 m-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            ></path>
          </svg>
        </div>

        <div class="relative max-w-screen-xl mx-auto px-4 z-10">
          <router-link
            to="/"
            class="inline-flex items-center text-sm font-semibold text-[#293146] dark:text-gray-200 hover:text-[#C5B47A] dark:hover:text-[#C5B47A] mb-6 transition-colors group"
          >
            <svg
              class="w-5 h-5 mr-2 transform group-hover:-translate-x-1 transition-transform"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
            Kembali ke Lowongan
          </router-link>

          <div
            class="bg-white dark:bg-gray-800 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] dark:shadow-none border border-gray-100 dark:border-gray-700 p-5 md:p-10 relative z-20"
          >
            <div class="flex flex-col md:flex-row items-center gap-6 text-center md:text-left">
              <div
                class="w-20 h-20 bg-yellow-100 dark:bg-yellow-900 rounded-2xl flex items-center justify-center text-[#C5B47A] dark:text-[#C5B47A] shrink-0"
              >
                <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
              </div>
              <div>
                <h1 class="text-2xl md:text-4xl font-black text-[#293146] dark:text-white mb-2">
                  Tentang Kami
                </h1>
                <p class="text-sm md:text-base text-gray-500 dark:text-gray-300 font-medium">
                  Mengenal lebih dekat platform lokerjambi.co.id
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Content -->
      <main class="max-w-4xl mx-auto px-4 mt-10">
        <div
          class="bg-white dark:bg-gray-800 rounded-3xl shadow-sm dark:shadow-none border border-gray-100 dark:border-gray-700 p-8 md:p-12 space-y-8"
        >
          <div class="prose max-w-none">
            <p class="text-xl text-gray-700 dark:text-gray-300 leading-relaxed font-medium">
              <span class="text-[#293146] dark:text-white font-black">Lokerjambi.co.id</span>
              adalah perusahaan rintisan startup dengan misi utama sebagai platform yang
              memaksimalkan kesempatan kerja setiap individu melalui akses layanan digitalisasi yang
              transparan dan terpercaya.
            </p>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
              <div
                class="p-6 bg-blue-50 dark:bg-gray-700/50 rounded-2xl border border-blue-100 dark:border-gray-600"
              >
                <h3 class="text-[#293146] dark:text-white font-bold text-lg mb-3 flex items-center">
                  <svg
                    class="w-5 h-5 mr-2 text-blue-600 dark:text-blue-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    ></path>
                  </svg>
                  Legalitas Resmi
                </h3>
                <p class="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                  Dikelola secara profesional oleh
                  <span class="font-bold text-gray-800 dark:text-gray-100"
                    >PT Uwais Digital Hired</span
                  >. Memiliki perizinan resmi dengan
                  <span class="font-bold text-gray-800 dark:text-gray-100">NIB: 704260109626</span>
                  dan terdaftar AHU-A082046.AH.01.30.Tahun 2026.
                </p>
              </div>
              <div
                class="p-6 bg-yellow-50 dark:bg-gray-700/50 rounded-2xl border border-yellow-100 dark:border-gray-600"
              >
                <h3 class="text-[#293146] dark:text-white font-bold text-lg mb-3 flex items-center">
                  <svg
                    class="w-5 h-5 mr-2 text-[#C5B47A] dark:text-[#C5B47A]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    ></path>
                  </svg>
                  Misi Kami
                </h3>
                <p class="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                  Menghubungkan talenta terbaik dengan perusahaan impian secara cepat dan mudah.
                  Kami berkomitmen untuk selalu menyajikan informasi lowongan yang akurat dan
                  terverifikasi.
                </p>
              </div>
            </div>

            <div class="mt-12 text-center">
              <p class="text-gray-500 dark:text-gray-400 italic mb-6">
                "Raih karir impianmu bersama platform lowongan kerja terpercaya di Jambi."
              </p>
              <router-link
                to="/contact"
                class="inline-flex items-center px-8 py-3 bg-[#293146] dark:bg-[#C5B47A] text-white dark:text-gray-900 font-bold rounded-xl hover:bg-[#3b4660] dark:hover:bg-yellow-500 transition-all shadow-lg hover:shadow-[#293146]/20 dark:hover:shadow-[#C5B47A]/20"
              >
                Hubungi Kami Sekarang
                <svg class="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  ></path>
                </svg>
              </router-link>
            </div>
          </div>
        </div>
      </main>
    </div>
    <AppFooter />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { initFlowbite } from 'flowbite';
import AppFooter from '../components/layout/AppFooter.vue';
import { useSeoMeta, getOrganizationSchema } from '../composables/useSeoMeta';

useSeoMeta({
  title: 'Tentang Kami',
  description:
    'Kenali lebih dekat Lokerjambi.co.id — platform lowongan kerja milik PT Uwais Digital Hired yang berkomitmen menghubungkan talenta terbaik dengan perusahaan impian di Jambi secara transparan dan terpercaya.',
  path: '/about',
  jsonLd: getOrganizationSchema(),
});

onMounted(() => {
  initFlowbite();
});
</script>

<style scoped>
@reference "../assets/main.css";

.prose p {
  @apply mb-4;
}
</style>
